export enum QueryParamEnum {
  Guid = "guid",
  BNR = "bnr",
  Voucher = "voucher",
}
